import React from 'react';
import ReactDOM from 'react-dom';
import { ModalProps } from './types';
import { ModalComponent } from './components/ModalComponent';
import './Modal.scss';

export const Modal = ({
  isVisible,
  setVisibility,
  children,
  usePortal = true,
  canEscape = true,
  className,
  overrideCss = false,
  displayCloseButton = false,
  modalSize,
  header,
}: React.PropsWithChildren<ModalProps>): JSX.Element | null => {
  if (usePortal) {
    return isVisible
      ? ReactDOM.createPortal(
          <ModalComponent
            isVisible={isVisible}
            setVisibility={setVisibility}
            canEscape={canEscape}
            className={className}
            overrideCss={overrideCss}
            modalSize={modalSize}
            displayCloseButton={displayCloseButton}
            header={header}
          >
            {children}
          </ModalComponent>,
          document.body
        )
      : null;
  }

  return isVisible ? (
    <ModalComponent
      isVisible={isVisible}
      setVisibility={setVisibility}
      canEscape={canEscape}
      className={className}
      overrideCss={overrideCss}
      modalSize={modalSize}
      displayCloseButton={displayCloseButton}
      header={header}
    >
      {children}
    </ModalComponent>
  ) : null;
};
